module.exports = __webpack_public_path__ + "static/dire_troll-a9e9f1fa407a2db826b929134f04a1e9.png";